/** The video id from any common YouTube link, or undefined. */
export function parseYouTube(url: string): string | undefined {
  const s = String(url ?? '').trim();
  const patterns = [
    /^https?:\/\/(?:www\.|m\.)?youtube\.com\/watch\?(?:.*&)?v=([\w-]{11})/,
    /^https?:\/\/youtu\.be\/([\w-]{11})/,
    /^https?:\/\/(?:www\.)?youtube\.com\/(?:embed|shorts|live)\/([\w-]{11})/,
  ];
  for (const p of patterns) {
    const m = s.match(p);
    if (m) return m[1];
  }
  return undefined;
}
